import type { AxiosError } from 'axios'

import type { ApiResponse } from './types'

// 错误类型枚举
export enum ErrorType {
  NETWORK = 'network', // 网络错误
  AUTH = 'auth', // 认证错误
  BUSINESS = 'business', // 业务错误
  VALIDATION = 'validation', // 参数验证错误
  PERMISSION = 'permission', // 权限错误
  SERVER = 'server', // 服务器错误
  TIMEOUT = 'timeout', // 超时错误
  UNKNOWN = 'unknown' // 未知错误
}

// 错误级别
export enum ErrorLevel {
  LOW = 'low', // 轻微错误，不影响主要功能
  MEDIUM = 'medium', // 中等错误，影响部分功能
  HIGH = 'high', // 严重错误，影响主要功能
  CRITICAL = 'critical' // 致命错误，系统不可用
}

// 处理后的标准化错误
export interface ProcessedError<T = unknown> {
  type: ErrorType
  level: ErrorLevel
  code: string
  message: string
  userMessage: string // 用户友好的错误提示
  context?: string // 错误上下文（如API路径）
  details?: T // 详细错误信息
  timestamp: number
  canRetry: boolean // 是否可重试
  retryOptions?: {
    maxRetries: number
    delay: number
  }
}

// 错误处理配置
export interface ErrorHandlerConfig {
  enableLogging?: boolean
  enableUserNotification?: boolean
  enableErrorReporting?: boolean
  defaultRetryOptions?: {
    maxRetries: number
    delay: number
  }
}

// 错误处理上下文
export interface ErrorContext {
  url?: string
  method?: string
  requestData?: unknown
  userId?: string
  timestamp: number
}

// Axios 错误类型守卫
export function isAxiosError(error: unknown): error is AxiosError<ApiResponse> {
  return typeof error === 'object' && error !== null && 'isAxiosError' in error
}

// 网络错误类型守卫
export function isNetworkError(error: AxiosError): boolean {
  return (
    !error.response &&
    (error.code === 'NETWORK_ERROR' ||
      error.code === 'ECONNREFUSED' ||
      error.code === 'ENOTFOUND' ||
      error.message.includes('Network Error'))
  )
}

// 超时错误类型守卫
export function isTimeoutError(error: AxiosError): boolean {
  return error.code === 'ECONNABORTED' || error.message.includes('timeout')
}
